$ = jQuery;

$.noConflict();
jQuery(document).ready(function($) {
    const nteJs = () => {
        // Selecting menuLinks and toTop elements
        var menuLinks = $('.sub-menu li a');
        var toTop = $('.to-top');
    
        // Adding click event handler to the toTop element
        toTop.on('click', function(e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $('.responsive-tabs').offset().top - 150
            }, 500); // You can adjust the animation speed (in milliseconds)
        });
    }
    
    nteJs(); // Call the nteJs function
});